// Emirates (EK) rate helpers. EK streams several products (GCR, AXA, ...) for
// the same flight, so requestRefId is not unique for EK — each rate is
// identified by its rateQuotationID (the airline's rateId) instead. Other
// carriers keep using requestRefId.

const EK_CARRIER_CODE = "EK";
const EK_AIRLINE_PREFIX = "176";

export function isEkRate(so) {
  const itinerary = so?.flightItineraries?.[0];
  return (
    itinerary?.carrierCode === EK_CARRIER_CODE ||
    String(itinerary?.airlinePrefix ?? "") === EK_AIRLINE_PREFIX
  );
}

// rateQuotationID for an EK rate (falls back to rateId); null for any other
// carrier or when the rate carries neither.
export function getEkRateQuotationID(so) {
  if (!isEkRate(so)) return null;
  return so?.rateQuotationID ?? so?.rateId ?? null;
}

// Identity key for a rate row: rateQuotationID for EK, requestRefId otherwise.
export function getRateKey(so) {
  return getEkRateQuotationID(so) ?? so?.requestRefId;
}
